<script setup lang="ts">
// Este componente é puramente de apresentação (estático), 
// portanto não necessita de estado local ou chamadas de serviço.
</script>

<template>
  <div class="footer">
    <div class="card clearfix">
      <span class="footer-text-left">Cassems - Tecnologia da Informação</span>
      <span class="footer-text-right">
        <!-- Substituído 'ui-icon ui-icon-copyright' legado pelo equivalente PrimeIcons 'pi pi-copyright' -->
        <i class="pi pi-copyright"></i> <span>All Rights Reserved</span>
      </span>
    </div>
  </div>
</template>

<style scoped>
/* 
 * As classes .footer, .card, .clearfix, .footer-text-left e .footer-text-right 
 * geralmente são tratadas pelo CSS global do layout (ex: templates Apollo/Sakai).
 * Caso não estejam no escopo global, os estilos estruturais básicos foram adicionados aqui.
 */
.clearfix::after {
  content: "";
  clear: both;
  display: table;
}

.footer-text-left {
  float: left;
}

.footer-text-right {
  float: right;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>